import styled, { css } from "styled-components";

export const FilterMenuOptionContainer = styled.div`
    border: 1px solid rgba(84, 95, 125, 0.14);
    box-shadow: 3px 5px 20px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
   background-color: #fff;
   position: absolute;
   min-width: 27rem;
   z-index: 90;
   padding: 6px 2rem 3rem 2rem;
   top: -767px;
   left: ${({ left }) => left};
   opacity: 0;
   visibility: hidden;
   transition: top 150ms ease-out 100ms;
   display:none;
   color: ${({ theme }) => theme.colors?.grey};

   ${({ visible, top }) =>
        visible &&
        css`
         top:  ${({ top }) => top};
         opacity: 1;
         visibility: visible;
         display: block;
      `}

`;
